/**
 * @generated SignedSource<<3aceb4e977822b1b264c820fc870c14e>>
 * @relayHash dea2e12264e968c66a4a6263ce201198
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 413334f10171efb9ca5d18c864ab9a965eceded335a35bb77a0ce1f22756f959

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteToEventInput = {
  email: string;
  eventId: string;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
};
export type EventScreenInviteDialogMutation$variables = {
  input: InviteToEventInput;
};
export type EventScreenInviteDialogMutation$data = {
  readonly inviteToEvent: {
    readonly success: boolean;
  };
};
export type EventScreenInviteDialogMutation = {
  response: EventScreenInviteDialogMutation$data;
  variables: EventScreenInviteDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InviteToEventPayload",
    "kind": "LinkedField",
    "name": "inviteToEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventScreenInviteDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventScreenInviteDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "413334f10171efb9ca5d18c864ab9a965eceded335a35bb77a0ce1f22756f959",
    "metadata": {},
    "name": "EventScreenInviteDialogMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "25b9b3f217a71326da652cb214b980d4";

export default node;
